




































































































































































import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

import "vue2-datepicker/scss/index.scss";
import Paginate from "@/components/Paginate.vue";

const ExpectedInvoices = namespace("InvoicesModule");

@Component({
  name: "ExpectedInvoice",
  components: {
    DatePicker,
    Paginate,
    Multiselect,
  },
  filters: {
    formatDate: function (value: any) {
      if (!value) {
        return "";
      }
      const cDate = new Date(value);

      return (
          cDate.getFullYear() +
          "-" +
          String(cDate.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(cDate.getDate()).padStart(2, "0")
      );
    },
  },
})
export default class ExpectedInvoice extends Vue {
  private urlRetrieve = "invoices/expected/search";
  private urlTotalAmount = "invoices/expected/total-amount";
  private currency = "EUR";
  private isLoading = false;
  private CreditorNameList = [];
  private DebtorNameList = [];
  private InvoiceTypeList = [];
  private totalInfo = {
    TotalAmountOpen: 0,
    TotalAmountArchived: 0,
    FilterAmountOpen: 0,
    FilterAmountArchived: 0,
  };
  private expectedInvoiceStatus = [
    {value: null, text: "Status"},
    {value: 1, text: "Open"},
    {value: 2, text: "Archived"},
  ];
  private invoices = [];
  private SortDate: any = null;
  private filter = {
    DateFrom: new Date(),
    DateTo: new Date(),
    Debtor: null,
    Creditor: null,
    BlockCode: null,
    InvoiceType: null,
    Status: null,
    NettAmount: null,
    GrossAmount: null,
    InvoiceNrSFS: null,
    showArchived: null,
    Sort: "",
    Index: "",
  };

  private paginate = {
    perPage: 0,
    totalRow: 0,
    currentPage: 0,
    limit: 0,
  };

  constructor() {
    super();
  }

  created() {
    this.searchData();
    this.calTotalAmount();
  }

  pageChange(params: any) {
    this.getItemPerPage({
      page: params.currentPage,
      filter: this.filterQuery(),
    }).then(
        (response) => {
          this.invoices = response.invoiceList;
          if (response.Paginate) {
            this.paginate = response.Paginate;
            this.CreditorNameList = this.creditorOptionList;
            this.DebtorNameList = this.debtorOptionList;
            this.InvoiceTypeList = this.invoiceTypeList;
          }
        }
    );
  }

  public sortDate(): void {
    if (this.SortDate == null) {
      this.SortDate = "desc";
    } else {
      this.SortDate = this.SortDate == "desc" ? "asc" : "desc";
    }
    this.filter.Sort = this.SortDate;
    this.filter.Index = "InvoiceDateSort";
    this.searchData();
  }

  public calTotalAmount(): void {
    //get total amount for all
    this.getTotalAmount({
      url: this.urlTotalAmount,
      data: {
        DateFrom: this.getDateString(this.filter.DateFrom),
        DateTo: this.getDateString(this.filter.DateTo),
        Filter: [],
      }
    }).then((response) => {
      this.totalInfo.TotalAmountOpen = response.data[0].TotalAmountOpen;
      this.totalInfo.TotalAmountArchived = response.data[0].TotalAmountArchived;
    });

    //get total amount for filter
    this.getTotalAmount({
      url: this.urlTotalAmount,
      data: {
        DateFrom: this.getDateString(this.filter.DateFrom),
        DateTo: this.getDateString(this.filter.DateTo),
        Filter: this.makeFilter(),
      },
    }).then((response) => {
      this.totalInfo.FilterAmountOpen = response.data[0].TotalAmountOpen;
      this.totalInfo.FilterAmountArchived = response.data[0].TotalAmountArchived;
    });
  }

  public searchData(): void {
    this.isLoading = true;
    this.retrieveInvoices(this.filterQuery()).then(
        (response) => {
          this.paginate = response.Paginate;
          this.invoices = response.invoiceList;
          this.CreditorNameList = this.creditorOptionList;
          this.DebtorNameList = this.debtorOptionList;
          this.InvoiceTypeList = this.invoiceTypeList;
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
        }
    );
    this.calTotalAmount();
  }

  private filterQuery() {
    const filter = this.filter;
    const filterData: any = {};
    const dateFrom = filter.DateFrom == null ? new Date() : filter.DateFrom;
    filterData.PartitionKey = dateFrom.getFullYear();

    //index using and sort
    if (filter.Index) {
      filterData.Index = filter.Index;
    }
    if (filter.Sort) {
      filterData.Sort = filter.Sort;
    }
    if (filter.showArchived) {
      filterData.Archived = true;
    }
    if (filter.BlockCode) {
      filterData.BlockCode = filter.BlockCode;
    }
    filterData.Filter = this.makeFilter();
    return {url: this.urlRetrieve, filterData: filterData};
  }

  private makeFilter() {
    const filter = this.filter;
    const Filter = [];

    Filter.push({
      Key: "DateOfPayment",
      Operator: "greatThanEqual",
      Value: this.getDateString(filter.DateFrom),
    });
    Filter.push({
      Key: "DateOfPayment",
      Operator: "lessThanEqual",
      Value: this.getDateString(filter.DateTo),
    });
    if (filter.Debtor) {
      Filter.push({
        Key: "DebtorName",
        Value: filter.Debtor,
      });
    }
    if (filter.Creditor) {
      Filter.push({
        Key: "CreditorName",
        Value: filter.Creditor,
      });
    }
    if (filter.InvoiceType) {
      Filter.push({
        Key: "InvoiceType",
        Value: filter.InvoiceType,
      });
    }
    if (filter.Status) {
      Filter.push({
        Key: "Status",
        Value: filter.Status,
      });
    }
    if (filter.BlockCode) {
      Filter.push({
        Key: "BlockCode",
        Operator: "contains",
        Value: filter.BlockCode,
      });
    }
    return Filter;
  }

  getDateString(value: Date): string {
    value = value == null ? new Date() : value;
    return (
        value.getFullYear() +
        "-" +
        String(value.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(value.getDate()).padStart(2, "0")
    );
  }

  notBeforeDateFrom(date: Date) {
    const dateFrom = new Date(this.filter.DateFrom);
    dateFrom.setHours(0, 0, 0, 0);
    return date.getTime() < dateFrom.getTime();
  }

  notAfterDateTo(date: Date) {
    const dateTo = new Date(this.filter.DateTo);
    dateTo.setHours(0, 0, 0, 0);
    return date.getTime() > dateTo.getTime();
  }

  @ExpectedInvoices.State
  public invoiceList!: Array<any>;

  @ExpectedInvoices.State
  public lastKey!: any;

  @ExpectedInvoices.State
  public creditorOptionList!: any;

  @ExpectedInvoices.State
  public debtorOptionList!: any;

  @ExpectedInvoices.State
  public invoiceTypeList!: any;

  @ExpectedInvoices.Action
  public retrieveInvoices!: (params: any) => Promise<any>;

  @ExpectedInvoices.Action
  public getTotalAmount!: (params: any) => Promise<any>;

  @ExpectedInvoices.Action
  public getItemPerPage!: (params: any) => Promise<any>;
}
